(function () {
  var SELECTOR = '[data-price-ht-ttc]';
  var QTY_SELECTOR = '.qty-input__input';

  var pristine = new WeakMap();

  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return format;

    var name = match[1];
    var decimals = name.indexOf('no_decimals') === -1 ? 2 : 0;
    var thousands = ',';
    if (name.indexOf('comma_separator') !== -1) {
      thousands = '.';
    } else if (name.indexOf('space_separator') !== -1) {
      thousands = ' ';
    } else if (name.indexOf('apostrophe_separator') !== -1) {
      thousands = "'";
    }
    var decimal = thousands === ',' ? '.' : ',';

    var value = (Math.abs(cents) / 100).toFixed(decimals);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var amount = decimals ? whole + decimal + parts[1] : whole;
    if (cents < 0) amount = '-' + amount;

    return format.replace(placeholder, amount);
  }

  function superscript(money, format, withCurrency) {
    if (format.indexOf('money') !== -1 || format.indexOf('.') !== -1) return money;
    var separator = format.indexOf('amount_with_comma_separator') !== -1 ? ',' : '.';
    var index = money.indexOf(separator);
    if (index === -1) return money;

    var result = money.slice(0, index) + '<sup>' + money.slice(index + 1);
    if (!withCurrency) return result + '</sup>';

    var lastSpace = result.lastIndexOf(' ');
    if (lastSpace === -1) return result + '</sup>';
    return result.slice(0, lastSpace) + '</sup> ' + result.slice(lastSpace + 1);
  }

  function render(cents, block) {
    var format = block.dataset.moneyFormat;
    var money = formatMoney(cents, format);
    if (block.dataset.supercents !== 'true') return money;
    return superscript(money, format, block.dataset.withCurrency === 'true');
  }

  function getQuantity(block) {
    var product = block.closest('.js-product');
    var input = product && product.querySelector(QTY_SELECTOR);
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  function update(block) {
    var totalHt = block.querySelector('[data-total-ht]');
    var totalTtc = block.querySelector('[data-total-ttc]');
    if (!totalHt || !totalTtc) return;

    if (!pristine.has(block)) {
      pristine.set(block, { ht: totalHt.innerHTML, ttc: totalTtc.innerHTML });
    }

    var qty = getQuantity(block);
    if (qty === 1) {
      var original = pristine.get(block);
      totalHt.innerHTML = original.ht;
      totalTtc.innerHTML = original.ttc;
      return;
    }

    var rate = parseFloat(block.dataset.taxRate) || 0;
    var priceBase = parseInt(block.dataset.priceBase, 10);
    if (isNaN(priceBase)) return;

    var base = priceBase * qty;
    var ht;
    var ttc;

    if (block.dataset.taxBase === 'ht') {
      ht = base;
      ttc = Math.round((base * (100 + rate)) / 100);
    } else {
      ttc = base;
      ht = Math.round((base * 100) / (100 + rate));
    }

    totalHt.innerHTML = render(ht, block);
    totalTtc.innerHTML = render(ttc, block);
  }

  function updateAll(root) {
    (root.matches && root.matches(SELECTOR) ? [root] : []).concat(
      Array.prototype.slice.call(root.querySelectorAll(SELECTOR))
    ).forEach(update);
  }

  document.addEventListener('change', function (evt) {
    if (!evt.target.matches || !evt.target.matches(QTY_SELECTOR)) return;
    var product = evt.target.closest('.js-product');
    if (product) updateAll(product);
  });

  document.addEventListener('on:variant:change', function (evt) {
    var product = evt.target.closest ? evt.target.closest('.js-product') : null;
    updateAll(product || document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    updateAll(evt.target);
  });

  updateAll(document);
})();
